import * as http from '@/util/http'
import { set, format } from 'date-fns'
import { queryClient } from '@/util/queryClient'
import { type ProgressFlag, saveProgress } from '@/util/progress'
import { fetchProgressFlags } from '@/util/progress'

function estimateEnrollmentStartDate(grade: number): Date {
  const currentYear = new Date().getFullYear()
  return set(new Date(), { year: currentYear - grade + 1, month: 3, date: 1 }) // month: 0-based，3 = 4月
}

export async function syncInterests(interestIds: number[]) {
  await http.put('/api/v1/user/profile/interest', {
    payload: interestIds,
  })
}

export async function syncOccupations(occupationIds: number[]) {
  await http.put('/api/v1/user/profile/occupation', {
    payload: occupationIds,
  })
}

export type EducationHistory = {
  programType: string
  schoolId: number
  academicProgramId?: number
  academicCourseId?: number
  grade: number
}

export async function syncEducationHistory({
  programType,
  schoolId,
  academicProgramId,
  academicCourseId,
  grade,
}: EducationHistory) {
  await http.put<number>('/api/v1/user/profile/education-history', {
    payload: [
      {
        programType,
        schoolId,
        academicProgramId,
        academicCourseId,
        enrollmentStartDate: format(estimateEnrollmentStartDate(grade), 'yyyy-MM-dd'),
      },
    ],
  })
}

export async function syncProgress(flags: ProgressFlag, syncDb: boolean = true) {
  const previousFlags = await queryClient.ensureQueryData<ProgressFlag>({
    queryKey: ['progress-flags'],
    queryFn: fetchProgressFlags,
    staleTime: Infinity,
  })

  try {
    if (syncDb) {
      await saveProgress(flags)
    }
    queryClient.setQueryData(['progress-flags'], () => previousFlags | flags)
  } catch (err) {
    console.log(err)
  }
}
